import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { mustBeTruthy } from 'src/app/services/customFormValidators';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { RewardsService } from 'src/app/services/rewards/rewards.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';

@Component({
  selector: 'app-player-migration-action',
  templateUrl: './player-migration-action.component.html',
  styleUrls: ['./player-migration.component.scss'],
})

export class PlayerMigrationActionComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  public bonusCode;
  public bonusIsVerified: boolean = false;
  public customer: CustomerModel;
  public error: any;
  public pageParams: any = {};
  public selectedBonusIndex;
  public welcomeOffers = [];
  public verifiedInputBonusCode: string;

  public infoForm: FormGroup;
  public certOver18: AbstractControl;
  public inputBonusCode: AbstractControl;
  public password: AbstractControl;
  public username: AbstractControl;

  constructor(
    public appLinksService: AppLinksService,
    public authenticationService: AuthenticationService,
    public configService: ConfigService,
    public globalErrorHandler: GlobalErrorHandlerService,
    public logoutService: LogoutService,
    public navigator: Navigator,
    public rewardService: RewardsService,
    public successMessageService: SuccessMessageService,
    public userSession: UserSessionService,
    public webcontentService: WebcontentService,
  ){}

  ngOnInit(): void {

    this.userSession.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;
      }
    });

    this.infoForm = new FormGroup({
      username: new FormControl({value: this.customer.userName, disabled: true}),
      password: new FormControl({value:'xxxxxxxxxxxxxx', disabled: true}),
      inputBonusCode: new FormControl(''),
      certOver18: new FormControl(false, [mustBeTruthy]),
    });

    this.inputBonusCode = this.infoForm.get("inputBonusCode");
    this.certOver18 = this.infoForm.get('certOver18');
  }

  public selectBonus(event): void {
    this.bonusCode = event;

    const bonuseCode =  typeof event === 'string' ? this.bonusCode : this.bonusCode.bonus
    if(bonuseCode === this.inputBonusCode?.value) {
      this.inputBonusCode?.setValue('')
      setTimeout(() => this.bonusChanged(null), 0);
    }
  }

  public onContinue(){
    this.pageParams.migrated = true;
    this.pageParams.certOver18 = true;

    let bonusCodeToSend: any;
    this.bonusIsVerified ? bonusCodeToSend = this.inputBonusCode.value : bonusCodeToSend = this.bonusCode.bonus;
    this.pageParams.bonusCode = bonusCodeToSend;

    return this.navigator.navigateTo("SignupStepTwoComponent", {}, { pageParams: this.pageParams });
  }

  public bonusChanged($event) {
		this.bonusIsVerified = false;
    this.verifiedInputBonusCode = ''
		if (this.inputBonusCode.value === '') {
			this.inputBonusCode.markAsPristine();
			this.inputBonusCode.setErrors({});
			this.infoForm.updateValueAndValidity();
			this.infoForm.enable();
      this.infoForm.controls['username'].disable();
      this.infoForm.controls['password'].disable();
		}
	}

  public verifyBonus() {
		let bonusCode = this.inputBonusCode.value;
		this.authenticationService.validateReferrerCode(bonusCode).subscribe(
			response => {
				if ('result' in response && response.result == '1') {
					this.selectedBonusIndex = 'input';
					this.bonusIsVerified = true;
					this.inputBonusCode.markAsPristine();
					this.inputBonusCode.markAsTouched();
					this.infoForm.markAsPristine();
					this.infoForm.markAsTouched();
					this.infoForm.updateValueAndValidity();
					this.infoForm.enable();
          this.infoForm.controls['username'].disable();
          this.infoForm.controls['password'].disable();
					this.error = '';
          this.verifiedInputBonusCode = bonusCode;
				} else{
          this.verifiedInputBonusCode = '';
        }
			}, error => {
        this.verifiedInputBonusCode = ''
				const code: string = error?.error?.code || '';
				let errorCode = code.toUpperCase();
				this.globalErrorHandler.setErrorCode(error.getErrorCode().toUpperCase());
				switch (errorCode) {
					case undefined:
						error.message = 'Promo code is invalid.';
						this.inputBonusCode.setErrors({ EMAIL_ALREADY_EXISTS: true });
						this.inputBonusCode.markAsTouched();
						this.inputBonusCode.markAsDirty();
						break;
					case 'INVALID_CODE':
						error.message = 'Promo code is invalid.';
						this.inputBonusCode.setErrors({ EMAIL_ALREADY_EXISTS: true });
						this.inputBonusCode.markAsTouched();
						this.inputBonusCode.markAsDirty();
						break;
					default:
						error.message = 'Promo code is invalid.';
						this.inputBonusCode.setErrors({ EMAIL_ALREADY_EXISTS: true });
						this.inputBonusCode.markAsTouched();
						this.inputBonusCode.markAsDirty();
				}
				this.bonusIsVerified = false;
				this.globalErrorHandler.setErrorMessage(error.message);
				this.error = error;
				this.content.scrollToTop();
				setTimeout(() => {
					this.error = '';
				}, 3500);
			}
		);
	}

  openMatchedExternalLinks(code, title){
    return this.appLinksService.openMatchedExternalLinksPopover(code, title)
  }

  onClose = () => {
    this.logoutService.callLogout();
  }

}
